<!-- accordion for branches (WIP)-->
<mat-card appearance="outlined" class="customer-portal-branches-container">
  <!-- If user is "incomplete", hide customer portal as it may still load if they have branch_ids -->
  @if (filterBranches) {
    <mat-accordion>
      @for (branch of filterBranches; track $index) {
        @if (isAccessSuspended(branch)) {
          <app-suspended-branch-row [branch]="branch" (manageBilling)="onManageBillingClicked(branch, $event)" />
        } @else {
        <mat-expansion-panel
          (opened)="onExpandBranch(branch.id)"
          [expanded]="branches.length === 1"
          [disabled]="selectedBranch && branch.id !== selectedBranch.id"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ branch.name }}
            </mat-panel-title>
            @if (evaluateViewBilling(branch.id)) {
              <div class="btn-container">
                <a panButton color="info" [routerLink]="['/home', 'manage', 'branch', branch.id, 'billing-history']">
                  View Billing History
                </a>
              </div>
            }
            @if (!!branch.stripe_customer_id) {
              <div>
                <div class="btn-container">
                  <button (click)="onManageBillingClicked(branch, $event)" class="btn manage-billing" mat-stroked-button>
                    <mat-icon
                      class="manage-billing material-icons-round"
                      matTooltip="Manage Billing"
                      matTooltipClass="multiline-tooltip"
                      matTooltipPosition="above"
                    >
                      credit_card
                    </mat-icon>
                    Manage Billing
                  </button>
                </div>
              </div>
            }
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            @if (expandedBranchId === branch.id) {
              @if (showFilter(branch)) {
                <mat-form-field>
                  <mat-label>Search Location</mat-label>
                  <input #input (keyup)="applySearchLocation($event, branch, table)" matInput placeholder="Ex. Mia" />
                </mat-form-field>
              }
              <table
                #table
                (matSortChange)="applySort($event, branch, table)"
                [dataSource]="branch.locations"
                class="mat-elevation-z8 locations-table"
                mat-table
                matSort
              >
                <!-- Location Name Column -->
                <ng-container matColumnDef="location_name">
                  <th *matHeaderCellDef mat-header-cell mat-sort-header>Location Name</th>
                  <td *matCellDef="let location" mat-cell>{{ location.location_name }} ({{ location.location_id }})</td>
                </ng-container>
                <!-- External ID Column -->
                <ng-container matColumnDef="external_id">
                  <th *matHeaderCellDef mat-header-cell mat-sort-header>External ID</th>
                  <td *matCellDef="let location" mat-cell>{{ location.external_id }}</td>
                </ng-container>
                <!-- Flagged column -->
                <ng-container matColumnDef="flagged">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Flagged</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <div>
                      @if (element.flagged) {
                        <mat-icon class="text-red-600" [matTooltip]="getFlaggedTooltip(element)"> flag </mat-icon>
                      }
                    </div>
                  </td>
                </ng-container>
                <!-- Camera Column -->
                <ng-container matColumnDef="camera_status">
                  <th *matHeaderCellDef mat-header-cell>Camera Status</th>
                  <td *matCellDef="let location" mat-cell>
                    <!--                            temporary solution for locations with no cameras -->
                    @if (location.cameras_info.cameras_list.length < 1) {
                      <div class="cameras-container">
                        <span style="font-size: 12px; color: grey">No Cameras</span>
                      </div>
                    }
                    <div class="cameras-container">
                      @for (camera of location.cameras_info.cameras_list; track camera) {
                        <mat-icon
                          [class.healthy]="camera.health_status === 'GREEN' && camera.connection_status === 'GREEN'"
                          [matTooltip]="this.getCameraTooltipText(camera)"
                          aria-hidden="false"
                          aria-label="video camera"
                          class="material-icons-round videocam-icon"
                          matTooltipClass="multiline-tooltip"
                          matTooltipPosition="above"
                        >
                          video_camera_front
                        </mat-icon>
                      }
                    </div>
                  </td>
                </ng-container>
                <!-- LP plan Column -->
                <ng-container matColumnDef="lp_plan">
                  <th *matHeaderCellDef mat-header-cell>Loss Prevention Plan</th>
                  <td *matCellDef="let location" mat-cell>
                    <div>
                      @if (editMode && selectedBranch.id === branch.id) {
                        <div>
                          <mat-form-field class="btn-plan" style="width: auto">
                            <mat-label>Select</mat-label>
                            <mat-select
                              [disabled]="isLocationEditable(location)"
                              [(value)]="selectedLocationPlanMap[location.location_id].current.price_id"
                            >
                              @for (price of getSelfServePrices(branch.customer_type, location.location_id); track price) {
                                <mat-option [value]="price.id">{{ price.product.name }}</mat-option>
                              }
                            </mat-select>
                            @if (selectedLocationPlanMap[location.location_id].current.price_id) {
                              <button
                                (click)="selectedLocationPlanMap[location.location_id].current.price_id = null"
                                aria-label="Clear"
                                mat-icon-button
                                matSuffix
                                [disabled]="isLocationEditable(location)"
                              >
                                <mat-icon>close</mat-icon>
                              </button>
                            }
                          </mat-form-field>
                        </div>
                      } @else {
                        <button [class]="getStripePlanLabel(location.stripe_price_id) ?? 'noplan'" class="btn-plan">
                          {{ getStripePlanLabel(location.stripe_price_id) ?? "no theft plan" }}
                        </button>
                      }
                    </div>
                  </td>
                </ng-container>

                <!-- Manage Access column -->
                <ng-container matColumnDef="manage_access">
                  <th *matHeaderCellDef mat-header-cell>Manage Access</th>
                  <td *matCellDef="let location" mat-cell>
                    <button
                      (click)="onManageAccessClick(branch, location)"
                      panRole
                      [roles]="['admin', 'branch-manager', 'branch-owner', 'market-manager', 'self-service']"
                    >
                      Edit
                    </button>
                  </td>
                </ng-container>

                <ng-container matColumnDef="report_link">
                  <th *matHeaderCellDef mat-header-cell>Suspicious Incidents Report</th>
                  <td *matCellDef="let location" mat-cell>
                    <div class="report-container">
                      @if (location.theft_report_link) {
                        <a [href]="location.theft_report_link" target="_blank">
                          <mat-icon>receipt</mat-icon>
                        </a>
                      } @else {
                        <span>None</span>
                      }
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="history">
                  <th *matHeaderCellDef mat-header-cell>History</th>
                  <td *matCellDef="let location" mat-cell>
                    <div class="history-container">
                      <a
                        panButton
                        target="_blank"
                        [routerLink]="['/home', 'manage', 'branch', branch.id, 'location', location.location_id]"
                        [queryParams]="{ subpage: 'change-history' }"
                        icon="history"
                      >
                        History
                      </a>
                    </div>
                  </td>
                </ng-container>

                <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
                <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
              </table>

              @if (isLoading) {
                <div class="loading-container">
                  <mat-progress-spinner mode="indeterminate" [diameter]="25"></mat-progress-spinner>
                  <span>Loading...</span>
                </div>
              }
            }
          </ng-template>
          @if (!isLoading && selfServeBranches.includes(branch.id)) {
            <mat-action-row>
              @if (editMode) {
                <div>
                  @if (presence[0]?.includes(branch.id.toString()) && presence[1]?.length > 1) {
                    <span>Someone else is editing this branch. You may need to refresh.</span>
                  }
                  <button mat-button color="primary" (click)="onSaveClicked(branch)" [disabled]="saving">
                    @if (saving) {
                      <mat-spinner diameter="20"></mat-spinner>
                    }
                    @if (!saving) {
                      <span>Save</span>
                    }
                  </button>
                  <button mat-button color="warn" (click)="onCancelClicked()">Cancel</button>
                </div>
              } @else {
                <button mat-button color="primary" (click)="onEditClicked(branch)">
                  <mat-icon
                    class="material-icons-round"
                    matTooltip="Edit Plans"
                    matTooltipClass="multiline-tooltip"
                    matTooltipPosition="above"
                  >
                    edit
                  </mat-icon>
                  Edit
                </button>
              }
            </mat-action-row>
          }
        </mat-expansion-panel>
        }
      }
    </mat-accordion>
  }
</mat-card>
<app-footer></app-footer>
